import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { requireModules } from '../../../route';
import { Route as procurementFiltersRoute } from '../../filters/route';
import { demandSearchSchema } from '../demand/demandFilters';

const ForecastSummaryPage = lazyRouteComponent(
  () => import('../ForecastSummaryPage'),
  'ForecastSummaryPage',
);

export const Route = createRoute({
  // Under the procurement filter route, which owns the shared filters.
  getParentRoute: () => procurementFiltersRoute,
  path: '/procurement/forecast/summary',
  // Filters, roll-up, sort and paging all live in the URL, so a filtered view
  // is something a buyer can send to a colleague. `runId` absent = the latest
  // production run that produced output.
  validateSearch: demandSearchSchema,
  staticData: {
    app: {
      // No nav entry of its own: it is a sub-item of Demand forecasting
      // (demand-forecasting/route.tsx, ForecastNavItems).
      // Stable id: the route id changed when it moved under the filter route.
      performance: { pageId: 'forecast-summary', readiness: 'route-rendered' },
      access: {
        modulesAnyOf: [ProductModule.PROCUREMENT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Inventory }],
      },
    },
  },
  component: ForecastSummaryPage,
  loader: () => ({
    crumb: msg('Demand forecast', { context: 'page breadcrumb' }),
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT],
    });
  },
});
